import React from 'react';
import PropTypes from 'prop-types';

const SalePrice = ({ currency, value }) => {
    const style = {
        color: '#3c3241',
    };

    const formattedValue = typeof value === 'number' 
        ? (Number.isInteger(value) ? value : value.toFixed(2))
        : value;
    return <strong style={style}>{`${currency}${formattedValue}`}</strong>;
};

SalePrice.propTypes = {
    currency: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
};

export default SalePrice;
